import gql from "graphql-tag"

export const ROUTE_LIST = gql`
  query allRoutes(
    $query: String
    $first: Int
    $skip: Int
    $filter: RouteInput
  ) {
    allRoutes(query: $query, first: $first, skip: $skip, filter: $filter) {
      id
      name
      createdAt
      isActive
      surveyArea {
        id
        properties {
          name
        }
      }
      colorCode
      points {
        id
        visitee {
          id
          fullName
        }
      }
    }
  }
`

export const ROUTE_BY_ID = gql`
  query routeDetail($id: ID!) {
    routeDetail(id: $id) {
      id
      isActive
      colorCode
      name
      category {
        id
        name
      }
      surveyArea {
        id
        properties {
          name
        }
      }
      points {
        id
        sequence
        visitee {
          id
          fullName
          number
          status
          routepoints {
            id
            route {
              id
              name
            }
          }
          address {
            id
            village
            address
            latitude
            longitude
          }
        }
      }
    }
  }
`
export const SURVEY_AREA_VENDORS = gql`
  query surveyAreaVendors(
    $surveyAreaId: Int!
    $query: String
    $first: Int
    $skip: Int
  ) {
    allVendorsBySurveyAreas(
      surveyAreaId: $surveyAreaId
      query: $query
      first: $first
      skip: $skip
    ) {
      id
      fullName
      number
      status
      routepoints {
        id
        route {
          id
          name
        }
      }
      address {
        id
        village
        address
        latitude
        longitude
      }
    }
  }
`

export const ROUTE_ASSIGNMENT_DETAIL = gql`
  query routeAssignmentDetail($id: ID!) {
    routeAssignmentDetail(id: $id) {
      id
      rrules
      startDate
      endTime
      startTime
      shouldTrack
      assignee {
        id
        fullName
        isStaff
      }
      assignedRoutePoints {
        id
        sequence
        visitee {
          id
          fullName
          number
          status
          address {
            id
            village
            address
            latitude
            longitude
          }
        }
      }
      route {
        id
        name
        colorCode
        surveyArea {
          id
          properties {
            name
          }
        }
        points {
          id
          sequence
          visitee {
            id
            fullName
            number
            status
            address {
              id
              village
              address
              latitude
              longitude
            }
          }
        }
      }
    }
  }
`

export const ROUTE_ASSIGNMENT_RECURRENCES = gql`
  query routeAssignmentReccurences(
    $query: String
    $first: Int
    $skip: Int
    $filter: RouteAssignmentFilterInput
    $start: DateTime
    $end: DateTime
  ) {
    allRouteAssignments(
      query: $query
      first: $first
      skip: $skip
      filter: $filter
    ) {
      id
      route {
        id
        name
      }
      assignee {
        id
        fullName
      }
      rrules
      recurrences(start: $start, end: $end)
    }
  }
`

export const ROUTE_POLYLINE = gql`
  query routePolyline($id: ID!) {
    routeDetail(id: $id) {
      id
      colorCode
      polyline {
        type
        coordinates
      }
    }
  }
`

export const ALL_BEATS = gql`
  query allBeats($query: String, $first: Int, $skip: Int, $date: Date) {
    allBeats(
      query: $query
      first: $first
      skip: $skip
      filter: { date: $date }
    ) {
      id
      assignee {
        id
        fullName
      }
      assignment {
        id
        route {
          id
          name
          surveyArea {
            id
            properties {
              name
            }
          }
        }
        beatVisitCount(date: $date)
        assignedRoutePointCount
      }
      summary {
        durationAvg {
          seconds
          hours
          minutes
        }
        placedOrderCount
        secondarySales
        dropSize
      }
      status
      startTime
      endTime
    }
  }
`

export const BEAT_DETAIL = gql`
  query beatDetail($id: ID!) {
    beatDetail(id: $id) {
      id
      summary {
        durationAvg {
          hours
          minutes
          seconds
        }
      }
      assignee {
        id
        fullName
        referenceId
        number
      }
      status
      date
      assignment {
        id
        polyline {
          type
          coordinates
        }
        route {
          id
          name
          colorCode
          surveyArea {
            id
            properties {
              name
            }
          }
        }
        assignedRoutePoints {
          id
          visitee {
            id
            fullName
            status
            address {
              id
              address
              latitude
              longitude
            }
            fullName
            number
          }
          sequence
          visitByBeat(beatId: $id) {
            id
            endTime
            duration {
              hours
              minutes
              seconds
            }
          }
        }
      }
      remark
    }
  }
`

export const BEAT_VISIT_DETAILS = gql`
  query beatVisitDetail($id: ID!) {
    beatVisitDetail(id: $id) {
      id
      remark
      attachments {
        id
        url
      }
      actions {
        id
        action
        actionDetails
      }
    }
  }
`
